<template>
    <div>
        <limitless-page-header :title="'Dokumentkategorier'">
            <template #header-elements>
                <limitless-page-header-button url="/documents" icon="icon-files-empty">Dokument</limitless-page-header-button>
                <limitless-page-header-button url="/documents/categories/0" icon="icon-plus3">Ny kategori</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/documents/categories/table'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="name" sort-order="asc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'DocumentCategoryList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            per_page: 25,
        },
        table_columns: [
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(data) {
            window.location.href = '/documents/categories/' + data.id;
        },
    },
};

</script>
